<script lang="ts">
  import { cn } from '$lib/utils';
  import type { AvatarStoryblok } from '$types/bloks';
  import CmsImage from './cms-image.svelte';

  let className: string | undefined = undefined;

  export { className as class };
  export let block: AvatarStoryblok;
  export let isSelected = false;
</script>

{#if block.image}
  {@const variant = block.variant || 'lg'}
  <div
    aria-label={`Avatar ${block.name ? `of ${block.name}` : ''}`}
    class={cn(
      'flex flex-col justify-center items-center text-primary hover:[&>div]:bg-primary/4 hover:[&>div]:border-primary/18 active:text-accent active:[&>div]:bg-transparent active:[&>div]:border-accent focus:[&>div]:ring',
      variant === 'lg' ? 'w-[74px]' : 'w-[58px]',
      isSelected &&
        'text-accent [&>div]:border-accent hover:[&>div]:border-accent hover:[&>div]:bg-accent/10',
      className
    )}
  >
    <div
      class={cn(
        variant === 'lg' ? 'w-[70px] h-[70px]' : 'w-[54px] h-[54px]',
        'transition-colors rounded-full p-[2px] border border-primary/14'
      )}
    >
      <CmsImage
        image={block.image}
        class={cn(variant === 'lg' ? 'w-16 h-16' : 'w-12 h-12', 'rounded-full object-cover')}
      />
    </div>
    <p class="transition-colors text-center text-xs mt-1">{block.name}</p>
  </div>
{/if}
